export const FilesPage = () => import(/* webpackChunkName: "files-page" */ "./pages/files-page");
